import { put, select, take } from 'redux-saga/effects';
import { replace } from 'redux-little-router';
import {
  getIncomeDataFailure,
  getNdfl2ByYear,
  starStepFetching,
  stopStepFetching,
} from 'modules/Taps/components/NDFL3Light/redux/actions';
import { GET_NDFL2_BY_YEAR_SUCCESS } from 'modules/Taps/components/NDFL3Light/redux/actionTypes';
import { selectDraft } from 'modules/Taps/components/NDFL3Light/selectors';

export default function* initIncomesSaga({ payload: { nextStep: step, hidden } }) {
  const draft = yield select(selectDraft);

  if (!draft) {
    return yield put(getIncomeDataFailure(new Error('draftNotFound')));
  } else if (hidden) {
    // if step is hidden - move to the next step
    return yield put(replace({ query: { cardId: draft.get('cardId'), step } }));
  }

  yield put(starStepFetching());

  const reportYear = draft.getIn(['payload', 'initialData', 'reportYear']);

  yield put(getNdfl2ByYear(reportYear));
  yield take(GET_NDFL2_BY_YEAR_SUCCESS);

  yield put(stopStepFetching());
}
